import React from "react";
import { i18n } from "@src/utils/i18n";
import CloseOutlined from "@cloud/atom-ui-icons/CloseOutlined";
import QuestionCircleOutlined from "@cloud/atom-ui-icons/QuestionCircleOutlined";
import { Modal, Tooltip } from "@cloud/atom-ui";
import * as nls from "../nls";
import useMappedState from "@src/utils/useMappedState";
import "./sytle.less";

export default props => {
  const I18N = i18n(nls);
  const text = I18N;
  const { tenant = {} } = useMappedState("root");
  const {
    publishModalVisible,
    isCheckModal,
    publishBtnLoading,
    handleSelectAdmin,
    adminUserList,
    deleteElement,
    handleCancel,
    handleUploadAuditFile
  } = props;
  return (
    <Modal
      destroyOnClose={true}
      maskClosable={false}
      okText={"申请发布"}
      title={
        isCheckModal === "Gray"
          ? text.grayPublish.name
          : text.editionPublish.name
      }
      visible={publishModalVisible}
      width={600}
      onOk={() => {
        handleUploadAuditFile(isCheckModal);
      }}
      onCancel={() => {
        handleCancel();
      }}
      okButtonProps={{ loading: publishBtnLoading }}
    >
      <div className={isCheckModal === "Gray" ? "checkTitle" : "checkTitle1"}>
        {tenant.isAutoAudit === "1"
          ? "当前应用免审核"
          : isCheckModal === "Gray"
          ? text.grayPublish.tip
          : text.editionPublish.tip}
      </div>
      {tenant.isAutoAudit === "0" && (
        <div className="selectAdmin">
          <span className="titles"> 通知管理员审核</span>
          <span
            className="selectBtn"
            onClick={() => {
              handleSelectAdmin();
            }}
          >
            +选择人员
          </span>
          <span className="selectTip">
            <Tooltip
              overlayStyle={{
                maxWidth: "200px",
                width: "200px",
                marginRight: "5px"
              }}
              placement="top"
              title={() => {
                return (
                  <div className="configInfo">
                    <div className="question">
                      选择指定管理员审核，默认提醒所有应用管理员审核
                    </div>
                  </div>
                );
              }}
            >
              <QuestionCircleOutlined
                style={{ marginLeft: "3px", color: "#ccc", fontSize: "14px" }}
              />
            </Tooltip>
          </span>
          {/*  默认带出来的人 */}
          <div className="selectedPerson">
            {adminUserList &&
              adminUserList.length > 0 &&
              adminUserList.map((item, index) => {
                return (
                  <span className="personItem" key={item.accountId}>
                    <span className="personName">{item.chineseName}</span>
                    <span
                      className="personRemove"
                      onClick={() => {
                        deleteElement(adminUserList, index);
                      }}
                    >
                      <CloseOutlined />
                    </span>
                  </span>
                );
              })}
          </div>
        </div>
      )}
    </Modal>
  );
};
